import React from "react";
import { objectToQueryString } from "@unisearch/helpers";
import { useRouter } from "next/router";
import { NewsVideoCard } from "@modules/study/common/news";
import styles from "./video_gallery.module.scss";

export const NewsVideoGallery = ({ videoGallery }) => {
  const router = useRouter();

  const pushToGallery = () => {
    let query = objectToQueryString({ limit: 7, page: 1, newsFormat: "video" });
    router.push({
      pathname: "/news/video",
      query: query,
    });
    return true;
  };

  return (
    <section>
      <div className="container">
        <div className={styles.heading_wrapper}>
          <h2 className={styles.heading}>Video Gallary</h2>
          <button
            onClick={pushToGallery}
            className={`btn btn-outline-grey btn-md btn-round ${styles.btn_view_all}`}
          >
            View All
          </button>
        </div>
        <div className={styles.video_gallery_wrapper}>
          {videoGallery &&
            videoGallery?.length > 0 &&
            videoGallery.map((post, i) => {
              return (
                <NewsVideoCard
                  data={post}
                  showDescription={i === 0}
                  key={i}
                  customClasses={{
                    cardClass: styles.video_item,
                    headClass: styles.video_head,
                    titleClass: styles.video_title,
                    featureImageClass: styles.video_image_wrapper,
                  }}
                />
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default NewsVideoGallery;
